export const version = "address/5.0.8";
//# sourceMappingURL=_version.js.map